import {
  createStore
} from 'vuex'
import api from '@/services/'

const store = createStore({
  state() {
    return {
      userInfo: null,
      studentVip: [],
      digitalBookList: [],
      classList: [],
      levelInfo: null,
      allAchievementList: [],
      catalogList: [],
      showReturn: 'home',
      phoneMode: false,
    }
  },
  mutations: {
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    studentVip(state, studentVip) {
      state.studentVip = studentVip;
    },
    digitalBookList(state, digitalBookList) {
      state.digitalBookList = digitalBookList;
    },
    classList(state, classList) {
      state.classList = classList;
    },
    levelInfo(state, levelInfo) {
      state.levelInfo = levelInfo;
    },
    allAchievementList(state, allAchievementList) {
      state.allAchievementList = allAchievementList;
    },
    catalogList(state, catalogList) {
      state.catalogList = catalogList;
    },
    showReturn(state, showReturn) {
      state.showReturn = showReturn;
    },
    phoneMode(state, phoneMode) {
      state.phoneMode = phoneMode;
    }
  },
  actions: {},
  modules: {}
})

export default store